import React, { useState, useEffect } from 'react';
import garden2 from '../assets/images/Conf_hall_2.jpg';

const images = garden2

const ConferenceHero = ({ language }) => {


  return (
    <section
      className="d-flex align-items-center text-white text-center"
      style={{
        backgroundImage: `url(${images})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '60vh',
        position: 'relative',
        transition: 'background-image 1s ease-in-out'
      }}
    >

    </section>
  );
};

export default ConferenceHero;













